module.exports = __webpack_public_path__ + "img/team_garrett2.12555127.jpg";